import './assets/CTAButton.css';const t = "_button_1cfcb_3", c = "_secondary_1cfcb_36", n = "_inverted_1cfcb_101", o = "_fullWidth_1cfcb_126", s = "_secondaryWidth_1cfcb_130", d = {
  button: t,
  secondary: c,
  inverted: n,
  fullWidth: o,
  secondaryWidth: s
};
export {
  d as s
};
